import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import profMenu from '../../menus/prof_menu';
import { getLeagueRankingForProfessor } from '../../Api/authApi.js.js';

// Breadcrumb "Trading Series > {page}" + pill "Jour X / Y" (maquette design-platform-prof/src/admin/app.jsx TopBar).
// Visible uniquement à partir du breakpoint desktop, quand la sidebar apparaît.
const TopBar = () => {
    const location = useLocation();
    const current = profMenu.find((item) => item.isActive(location.pathname));
    const label = current?.label || '';

    const professeurId = useSelector((state) => state.auth.user?.id);
    const [session, setSession] = useState(null); // { day, totalDays }

    useEffect(() => {
        if (!professeurId) return;
        getLeagueRankingForProfessor(professeurId)
            .then(res => {
                if (res?.session_day && res?.session_total_days) {
                    setSession({ day: res.session_day, totalDays: res.session_total_days });
                }
            })
            .catch(() => {});
    }, [professeurId]);

    return (
        <div className="hidden lg:flex" style={{
            alignItems: 'center', justifyContent: 'space-between',
            padding: '18px 32px',
            borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}>
            <div style={{ fontSize: 12.5, color: '#5C6B88', display: 'flex', alignItems: 'center', gap: 6 }}>
                <span>Trading Series</span>
                <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 6l6 6-6 6"/>
                </svg>
                <span style={{ color: '#97A4BE' }}>{label}</span>
            </div>

            {session && (
                <div className="mono" style={{
                    fontSize: 12.5, padding: '5px 12px', borderRadius: 999,
                    background: 'rgba(224,194,129,0.14)', color: '#E0C281',
                    border: '1px solid rgba(224,194,129,0.25)',
                }}>
                    Jour {session.day} / {session.totalDays}
                </div>
            )}
        </div>
    );
};

export default TopBar;
